/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * HeroImageSectionFront.jsx
 * Created by Destin Frasier on 12/07/21
 * Updated by Destin Frasier on 05/09/23
 */

import PropTypes from 'prop-types';
import { HeroImageSectionFront } from 'sarsaparilla';

export default function HeroImage({ heroTitle }) {
    return (
        <HeroImageSectionFront
            semanticElementName="section"
            title={heroTitle}
            className="ugc-hero-section mb-6"
            overlayImagePath={`${process.env.CDN}/img/splash-page/hero/share-your-story-logo`}
            overlayImageAltText="Share Your Adventure Logo"
            overlayImagePositionBottom="84px"
            overlayImagePositionLeft="0"
            hideTitle
            backgroundImagePath="/img/splash-page/hero/splash-page-hero"
            backgroundImageAltText="A group of woman celebrating on top of a mountain"
            backgroundImageColorOverlay="#1C1D1F"
            backgroundImageColorOverlayOpacity={0.05}
        />
    );
}

HeroImage.propTypes = {
    heroTitle: PropTypes.string,
};
